module.exports = "/_next/static/images/6f2f44c799107e6062ea608babfdff5f-time.png.webp";